import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

export default function StructureSetTitle() {
    return (
        <Box
            display="flex"
            gap={0.5}
            alignItems="center"
            sx={(theme) => ({
                color: theme.palette.primary.main,
            })}
        >
            <Typography fontSize={12} color="primary">
                <FormattedMessage id="structureSet" />
            </Typography>
        </Box>
    );
}
